var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "nav nav-tabs" },
    _vm._l(_vm.orderedTiedBrokerages, function (brokerage) {
      return _c(
        "li",
        {
          key: brokerage.brokerageId,
          staticClass: "nav-item clickable change-brokerage",
          class: {
            "nav-item-active": brokerage.brokerageId === _vm.selectedBrokerage,
          },
          attrs: { id: "brokerage-" + brokerage.brokerageId },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column nav-link grey-text text-darken-3 clickable",
              on: {
                click: function ($event) {
                  return _vm.navigateToBrokerage(brokerage.brokerageId)
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(brokerage.name))]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.lastBrokerNameByBrokerage[brokerage.name])),
              ]),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }